import { render } from "./WorkerRatesDataTable.vue?vue&type=template&id=89af6932&scoped=true&ts=true"
import script from "./WorkerRatesDataTable.vue?vue&type=script&lang=ts"
export * from "./WorkerRatesDataTable.vue?vue&type=script&lang=ts"

import "./WorkerRatesDataTable.vue?vue&type=style&index=0&id=89af6932&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89af6932"]])

export default __exports__